module.exports = __webpack_public_path__ + "img/ic_map_hotel_label_3_stars.1631a500.svg";